<template>
    <div>
        <b-modal
            id="clockOutModal"
            ref="clockOutModal"
            :lazy="true"
            title-tag="h2"
            title="Clock Out"
        >
            <!-- Modal Form -->
            <form class="form-horizontal">
                <div class="form-group row">
                    <label for="current" class="col-sm-3 col-form-label"
                        >Date:</label
                    >
                    <div class="col-sm-9">{{ clock_in_date }}</div>
                </div>
                <div class="form-group row">
                    <label for="new" class="col-sm-3 col-form-label"
                        >Clock In:</label
                    >
                    <div class="col-sm-9">{{ clock_in_time }}</div>
                </div>
                <div class="form-group row">
                    <label for="new" class="col-sm-3 col-form-label"
                        >Clock Out:</label
                    >
                    <div class="col-sm-9">{{ business_clock_end }}</div>
                </div>
                <div class="form-group row">
                    <label for="current" class="col-sm-3 col-form-label"
                        >Staff Notes:</label
                    >
                    <div class="col-sm-9">
                        <textarea
                            id="comments"
                            v-model="data.comments"
                            class="form-control"
                            placeholder="Notes (optional)"
                            style="height: 80px !important;"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.clockOutModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="clockOut" v-else variant="primary"
                        >Clock Out</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {
                clock_end: null,
                comments: null
            },
            time_sheet: {},
            clock_in_date: null,
            clock_in_time: null,
            business_clock_end: null,
            date_format: "DD/MM/YYYY",
            time_format: "h:mm A",
            loading: false
        };
    },
    computed: {},
    methods: {
        open() {
            this.getClockOut();

            this.date_format = this.getDateFormat();
        },
        getClockOut() {
            let self = this;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff/clock-out")
                .then(function (response) {
                    if (response.data.response.message.code == 200) {
                        self.data.clock_end =
                            response.data.response.resource.message.clock_end;
                        self.time_sheet =
                            response.data.response.resource.message.time_sheet;
                        self.data.comments = self.time_sheet.comments;

                        self.clock_in_date = moment
                            .unix(self.time_sheet.clock_in_time)
                            .tz(self._timeZone)
                            .format(self.date_format);
                        self.clock_in_time = moment
                            .unix(self.time_sheet.round_clock_in_time)
                            .tz(self._timeZone)
                            .format(self.time_format);

                        self.business_clock_end = moment
                            .unix(
                                response.data.response.resource.message
                                    .round_clock_end
                            )
                            .tz(self._timeZone)
                            .format(self.time_format);

                        self.$refs.clockOutModal.show();
                    } else {
                        self.$root.$emit(
                            "message",
                            response.data.response.resource.message,
                            "danger"
                        );
                    }
                });
        },
        clockOut() {
            let self = this;

            self.loading = true;

            let post = {
                clock_end: self.data.clock_end,
                comments: self.data.comments
            };
            return this.$http
                .post(process.env.ACTOR_SERVICE + "staff/clock-out", post)
                .then(function (response) {
                    if (response.data.response.message.code == 200) {
                        if (response.data.response.resource.message)
                            self.$root.$emit(
                                "message",
                                response.data.response.resource.message,
                                "success"
                            );

                        self.$root.timesheet.clock_in = true;
                        self.$root.timesheet.clock_out = false;

                        /**
                         * below functions are all todo
                         */
                        if ($("#tbl-time-sheet").is(":visible")) {
                            // TIME_SHEET.all();
                        }

                        if (response.data.response.resource.data.storage_key) {
                            localStorage.removeItem(
                                response.data.response.resource.data.storage_key
                            );
                        }

                        if (response.data.response.resource.data.logout) {
                            setTimeout(function () {
                                if (typeof newrelic !== "undefined") {
                                    // eslint-disable-next-line no-undef
                                    newrelic.addPageAction("view-logout", {
                                        reason: "clockout",
                                        file: "clock-out.vue"
                                    });
                                }

                                window.location =
                                    self.env.APPS + "index.php/welcome/logout";
                            }, 1000);
                        }

                        self.$refs.clockOutModal.hide();
                    } else {
                        self.$root.$emit(
                            "message",
                            response.data.response.resource.message,
                            "danger"
                        );
                    }
                })
                .finally(() => (self.loading = false));
        }
    }
};
</script>
